import { mockListMyBenefits } from "./MyBenefitsMock";
import { useLongfansMock } from "../global/GlobalMock";
import { post } from "../utils/Backend";
import type { ListMyBenefitsQuery, ListMyBenefitsResult } from "./MyBenefitsType";

/** 关闭 mock 时保持 `&& false`（见 frontend-data-mock-rule）。 */
const mockMyBenefits = false;

export const MyBenefitsApi = {
  listMyBenefits: (p: ListMyBenefitsQuery): Promise<ListMyBenefitsResult | string> => {
    if (useLongfansMock && mockMyBenefits) {
      return Promise.resolve(mockListMyBenefits(p));
    }
    return post<typeof p, ListMyBenefitsResult>("/lark/app/user/listMyBenefits", p);
  },
};
